(() => {
  class PdpDetailsAccordions {
    constructor(section) {
      this.section = section;
      this.handleClick = this.handleClick.bind(this);
      this.section.addEventListener('click', this.handleClick);
      this.section.pdpDetailsAccordions = this;
    }

    handleClick(event) {
      const trigger = event.target.closest('.pdp-accordion__trigger');
      if (!trigger || !this.section.contains(trigger)) return;

      const item = trigger.closest('.pdp-accordion');
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!item || !panel) return;

      const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
      trigger.setAttribute('aria-expanded', String(shouldOpen));
      item.classList.toggle('is-open', shouldOpen);
      panel.hidden = !shouldOpen;
    }

    destroy() {
      this.section.removeEventListener('click', this.handleClick);
      this.section.pdpDetailsAccordions = null;
    }
  }

  const initPdpDetailsAccordions = (scope = document) => {
    scope.querySelectorAll('[data-pdp-accordions]').forEach((section) => {
      if (section.pdpDetailsAccordions) return;
      new PdpDetailsAccordions(section);
    });
  };

  window.initPdpDetailsAccordions = initPdpDetailsAccordions;
  initPdpDetailsAccordions();

  if (!window.pdpDetailsAccordionsLifecycleBound) {
    document.addEventListener('shopify:section:load', (event) => {
      window.initPdpDetailsAccordions?.(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-pdp-accordions]').forEach((section) => {
        section.pdpDetailsAccordions?.destroy();
      });
    });
    window.pdpDetailsAccordionsLifecycleBound = true;
  }
})();
